import React from 'react';
import { Coupon } from '../Types/discount';

interface CouponInputProps {
  code: string;
  onCodeChange: (code: string) => void;
  couponInfo: Coupon | null;
  originalCode: string;
  disabled?: boolean;
}

export const CouponInput: React.FC<CouponInputProps> = ({
  code,
  onCodeChange,
  couponInfo,
  originalCode,
  disabled = false,
}) => {
  const isDisabled = disabled || (!!couponInfo?.id && code === originalCode);

  return (
    <div className="flex flex-col gap-2">
      <label className="text-[#333333] text-sm leading-[100%] font-medium">
        Coupon Code
      </label>
      <div className="relative">
        <input
          value={code}
          onChange={(e) => onCodeChange(e.target.value.toUpperCase())}
          disabled={isDisabled}
          placeholder="Enter coupon code"
          className={`w-full py-3 px-4 border border-gray-200 rounded-lg focus:border-[#1B4ED7] focus:ring-1 focus:ring-[#1B4ED7] font-medium transition-colors ${
            isDisabled
              ? "bg-gray-50 cursor-not-allowed text-gray-500"
              : "bg-white text-gray-900"
          }`}
        />
      </div>
    </div>
  );
};